
import {
    ESPECIE_HOME_LOADING,
    ESPECIE_HOME_LOADED,
    ESPECIE_HOME_ERROR,

    ESPECIE_PANEL_LOADING,
    ESPECIE_PANEL_LOADED,
    ESPECIE_PANEL_ERROR,

    ESPECIE_HOME_INDI_LOADING,
    ESPECIE_HOME_INDI_LOADED,
    ESPECIE_HOME_INDI_ERROR,

    ESPECIE_DETALIS_INDI_LOADING,
    ESPECIE_DETALIS_INDI_LOADED,
    ESPECIE_DETALIS_INDI_ERROR,
  } from './../../types/especie';

const INITIAL_STATE = {
    detailLoading: false,
    detailLoaded:false,
    detail:[],
    detailerror:'',

    especieLoading: false,
    especieLoaded: false,
    especie: [],
    especieerror: '',

    especiepanelLoading: false,
    especiepanelLoaded: false,
    especiepanel: [],
    especiepanelerror: '',

    espeindiLoading:false,
    espeindiLoaded:false,
    espeindi:[],
    espeindierror:'',
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type){
        case ESPECIE_DETALIS_INDI_LOADING:
            return {
                ... state,
                detailLoading: true,
                detailLoaded:false,
                detail:[],
                detailerror:'',
            }
        case ESPECIE_DETALIS_INDI_LOADED:
            return {
                ...state,
                detailLoading: false,
                detailLoaded:true,
                detail:action.payload,
                detailerror:'',
            };
        case ESPECIE_DETALIS_INDI_ERROR:
            return {
                ...state,
                detailLoading: false,
                detailLoaded:false,
                detail:[],
                detailerror:action.payload,
            }


        case ESPECIE_HOME_INDI_LOADING:
            return {
                ... state,
                espeindiLoading : true,
                espeindiLoaded : false,
                espeindi: [],
                espeindierror: ''
            }
        case ESPECIE_HOME_INDI_LOADED:
            return {
                ...state,
                espeindiLoading : false,
                espeindiLoaded : true,
                espeindi: action.payload,
                espeindierror: ''
            };
        case ESPECIE_HOME_INDI_ERROR:
            return {
                ...state,
                espeindiLoading : false,
                espeindiLoaded : false,
                espeindi: [],
                espeindierror: action.payload
            }

        case ESPECIE_HOME_LOADING:
            return {
                ... state,
                especieLoading : true,
                especieLoaded : false,
                especie: [],
                especieerror: ''
            }
        case ESPECIE_HOME_LOADED:
            return {
                ...state,
                especieLoading : false,
                especieLoaded : true,
                especie: action.payload,
                especieerror: ''
            };
        case ESPECIE_HOME_ERROR:
            return {
                ...state,
                especieLoading : false,
                especieLoaded : false,
                especie: [],
                especieerror: action.payload
            }

        case ESPECIE_PANEL_LOADING:
            return {
                ... state,
                especiepanelLoading : true,
                especiepanelLoaded : false,
                especiepanel: [],
                especiepanelerror: ''
            }
        case ESPECIE_PANEL_LOADED:
            return {
                ...state,
                especiepanelLoading : false,
                especiepanelLoaded : true,
                especiepanel: action.payload,
                especiepanelerror: ''
            };
        case ESPECIE_PANEL_ERROR:
            return {
                ...state,
                especiepanelLoading : false,
                especiepanelLoaded : false,
                especiepanel: [],
                especiepanelerror: action.payload
        }

        default: return state;
    }
}